import * as React from 'react';
import { UserPlusIcon } from '@heroicons/react/20/solid';
import { Grid, Input } from '@nextui-org/react';
import {
  GetAllowedEmailsDocument,
  useAddAllowedEmailMutation,
} from '@src/generated/hooks';
import { AppLoadingButton } from '@src/layouts/app/AppLoadingButton';

interface AddUserProps {}

/**
 * @name AddUser
 * @description tbd...
 */
export function AddUser(_props: AddUserProps) {
  // const {} = prop

  // GraphQL
  const [email, setEmail] = React.useState('');
  const [addAllowedEmailMutation, { loading }] = useAddAllowedEmailMutation({
    refetchQueries: [{ query: GetAllowedEmailsDocument }],
  });

  // Handlers
  const onAddUser = async () => {
    await addAllowedEmailMutation({
      variables: {
        email: email.trim(),
      },
    });
    setEmail('');
  };

  return (
    <Grid.Container gap={1} css={{ p: 0 }}>
      <Grid xs={12} sm={4}>
        <Input
          placeholder="user@pitchblend.com"
          aria-labelledby="Email"
          fullWidth
          animated={false}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              onAddUser();
            }
          }}
        />
      </Grid>
      <Grid xs={12} sm={2}>
        <AppLoadingButton
          css={{ w: 'stretch' }}
          onPress={onAddUser}
          loading={loading}
          icon={<UserPlusIcon width={20} height={20} />}
        >
          Add User
        </AppLoadingButton>
      </Grid>
    </Grid.Container>
  );
}
